import { useEffect, useRef } from "react";
import { statusLabel, statusColor } from "./constants";

// Options offered by the picker before an order is in the tork.
// "ongoing" is included so an employee can start the tork straight from the
// picker; selecting it opens the start-tork form instead of a plain status change.
const OPTIONS = ["planned", "unplanned", "closednotstarted", "ongoing"];

const OPTION_HINTS = {
    planned: "Order registrerad, ej lastad",
    unplanned: "Order ej planerad för torkning",
    closednotstarted: "Lastad i tork, ej startad",
    ongoing: "Starta torken – fyll i tider",
};

/* Small popover for changing an order's status while it is still pre-tork.
   - Selecting planned/closednotstarted -> onStatusChange(status)
   - Selecting ongoing -> onStart() (opens the start-tork form) */
const OrderStatusPicker = ({ value, onStatusChange, onStart, onClose }) => {
    const panelRef = useRef(null);

    useEffect(() => {
        const handler = (e) => {
            if (panelRef.current && !panelRef.current.contains(e.target)) onClose();
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, [onClose]);

    const select = (status) => {
        if (status === value) { onClose(); return; }
        if (status === "ongoing") onStart();
        else onStatusChange(status);
        onClose();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/20 p-4">
            <div
                ref={panelRef}
                className="bg-white rounded-lg shadow-xl border border-gray-200 w-96 flex flex-col"
            >
                <div className="flex items-center justify-between px-4 py-3 border-b">
                    <h3 className="text-sm font-semibold text-gray-800">Ändra status</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-lg leading-none">×</button>
                </div>

                <div className="p-2">
                    {OPTIONS.map(status => (
                        <button
                            key={status}
                            onClick={() => select(status)}
                            className={
                                "w-full text-left px-3 py-2 rounded-lg hover:bg-gray-50 transition flex items-center gap-2 " +
                                (status === value ? "bg-blue-50" : "")
                            }
                        >
                            <span className={"px-2 py-0.5 rounded-full text-xs whitespace-nowrap " + statusColor(status)}>
                                {statusLabel(status)}
                            </span>
                            <span className="text-xs text-gray-500 whitespace-nowrap">{OPTION_HINTS[status]}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default OrderStatusPicker;
